import { Flex, Progress } from 'antd'

import { Tooltip, useTheme } from '@suntex.fim/ui'

function StickerCharts({
  value,
  graphColor,
  maxValue
}: {
  graphColor: string
  value: number
  maxValue?: number
}) {
  const theme = useTheme()
  /**
  Here we calculate the step value displayed on the graph and the tooltip value based on maxvalue.
  As in the algebra report, we have different maxvalue for different graphs so we pass it through the parent component.
  This component is used for the Goal index report so we keep maxValue optional.
  Based on the value received for each graph we calculate the count and using this we calculate stepsize
  which is used to display the label below the graph and convert the value that fits the graph scale
  Here ** used for power operation (i.e 10**2=100)
   */
  const DEFAULT_STEP_COUNT = 11
  const SCALE_MULTIPLIER = 10
  const PERCENTAGE_MULTIPLIER = 100
  const DECIMAL_PLACES = 2
  let step = DEFAULT_STEP_COUNT
  const count = Math.round(value).toString().length
  const stepSize = SCALE_MULTIPLIER ** (count - 1)
  let graphValue = (value * SCALE_MULTIPLIER) / stepSize
  let tooltipValue = value
  if (maxValue) {
    graphValue = +((value / maxValue) * PERCENTAGE_MULTIPLIER).toFixed(
      DECIMAL_PLACES
    )
    tooltipValue = value
    step = maxValue
  }

  return (
    <div>
      <Tooltip
        classNames={{ root: 'progress-tooltip' }}
        arrow={false}
        placement="top"
        key="activity"
        title={'' + tooltipValue}
      >
        <Progress
          strokeColor={graphColor}
          percent={graphValue}
          showInfo={false}
          size={['100%', 24] as const}
          className="custom-step-progress"
        />
      </Tooltip>
      <Flex justify="space-between" className="x-axis">
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
        {[...Array(step)].map((_, i) => (
          <p key={i}>{i * stepSize}</p>
        ))}
      </Flex>
    </div>
  )
}

export default StickerCharts
